import React, {useState, useEffect} from "react";
import {Container, Row, Col, Card, CardBody} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Link} from "react-router-dom";
import AuthService from "../login/AuthService";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import moment from "moment";
import {Avatar, Button, DatePicker, Input, Pagination} from "antd";
import locale from "antd/es/date-picker/locale/pt_BR";
import Skeleton from "react-loading-skeleton";
import "bootstrap/dist/css/bootstrap.min.css";
import {Modal} from "bootstrap";
import Select from "react-select";

import DocumentDocTypeModal from './DocumentDocTypeModal';
import DocumentSelectRequiredModal from "./DocumentSelectRequiredModal";
import ImportModal from "../import/ImportModal";
import AnalysisUserModal from "./AnalysisUserModal";
import "./assets/css/Accreditation.css";
import UsersSearch from "../dashboard/calender/UsersSearch";
import UserRegisterModal from "./UserRegisterModal";
import CustomPagination from "../util/CustomPagination";
import ModalCompanyConfigAccreditation from "./ModalCompanyConfigAccreditation";
import AccreditationCommentsModal from "./AccreditationCommentsModal";
import dayjs from "dayjs";

const {RangePicker} = DatePicker;


const ManagersAvaliableUserPage = () => {
    document.title = "Avaliação de Usuário | Plantão Rápido";
    const [showCommentsModal, setShowCommentsModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [arrayCompany, setArrayCompany] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [searchFilters, setSearchFilters] = useState({
        dateRange: [],
        status: "",
        user_id: "",
    });
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});

    useEffect(() => {
        fetchArrayCompany();
    }, []);



      const fetchArrayCompany = async (page = 1) => {

        setLoading(true);

        try {
            // Define o responseType baseado em isExport
              const params = {
                pagination: pagination.pageSize,
                page: page,
                duty_datestart: searchFilters?.datestart,
                duty_dateend:  searchFilters?.dateend,
                dutyInfo: true
            };


            if (searchFilters.user_id) {
                params.user_id = searchFilters.user_id;
            }

            const response = await ApiService.send(
                "get",
                `${process.env.REACT_APP_URL_API}documents/managers-user-available`,
                params,
                true

            );


                // Se não for exportação, trata a resposta JSON normalmente
                const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
                setArrayCompany(data || []);
                setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };




    const handleClearFilters = () => {
        setSearchFilters({
            dateRange: [],
            status: "",
            name: "", // Limpar o nome do usuário
            cpfCnpj: "", // Limpar o filtro de CPF/CNPJ
            user_id: "", // Limpar o filtro de CPF/CNPJ
        });
        setPagination({...pagination, current: 1});
        fetchArrayCompany();
    };

    const handleApprove = (user) => {
        handleStatusChange('accepted', user);
    };

    const handleReject = (user) => {
        handleStatusChange('refused', user);
    };

    const handleStatusChange = (status, user) => {
        setLoading(true);

        const data = {
            user_interested: user.user_info.id,
            situation: status,
        };

        // Define a rota com base no status
        const endpoint = status === 'accepted'
            ? `${process.env.REACT_APP_URL_API}documents/approve`
            : `${process.env.REACT_APP_URL_API}documents/reject`;

        ApiService.send("post", endpoint, data, true)
            .then((res) => {
                if (res.code === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Sucesso!',
                        text: `Solicitação ${status === 'accepted' ? 'aprovada' : 'rejeitada'} com sucesso.`,
                    }).then(() => {
                        fetchArrayCompany(pagination.current);
                    });
                }
            })
            .catch((error) => {
                console.error(`Erro ao ${status === 'accepted' ? 'aprovar' : 'rejeitar'} solicitação:`, error);
                Swal.fire({
                    icon: 'error',
                    title: 'Erro!',
                    text: error.response?.data?.message || `Ocorreu um erro ao ${status === 'accepted' ? 'aprovar' : 'rejeitar'} a solicitação.`,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    };


    const onUserSelect = (users) => {
        setSearchFilters({...searchFilters, user_id: users?.value || null});
    };

    const closeCommentsModal = (save = false ) => {
        setShowCommentsModal(false);
        setShowCommentsModal(false);
        if(save) {
            fetchArrayCompany(pagination.current);
        }
    };

    const handleModalComments = (user) => {
        setSelectedUser(user);
        setShowCommentsModal(true);
    };


    const handlePageChange = (page) => {
        fetchArrayCompany(page);

    };

    const handleSearchFiltersChange = (key, value) => {
        setSearchFilters(prev => ({
            ...prev,
            [key]: value
        }));
    };



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Avaliação"  pageSubTitle="Usuário " pageTitle="Credenciamento "/>
                    <Row>
                        <div className="row mt-4 mb-4">

                                <div className="col-6 form-group">
                                    <UsersSearch
                                        onUserSelect={onUserSelect}
                                    />
                                </div>
                                <div className="col-4 form-grou">
                                    <div className="form-group ">
                                        <label>Data Plantão</label>
                                        <div className="form-control">
                                            <RangePicker
                                                style={{border: "none", boxShadow: "none"}}
                                                locale={locale}
                                                format="DD/MM/YYYY"
                                                className="range-picker-custom"
                                                value={searchFilters.dateRange.length > 0 ? searchFilters.dateRange : null}
                                                onChange={(dates) => {
                                                    if (dates) {
                                                        handleSearchFiltersChange("dateRange", dates);
                                                        handleSearchFiltersChange("datestart", dayjs(dates[0]).format("YYYY-MM-DD"));
                                                        handleSearchFiltersChange("dateend", dayjs(dates[1]).format("YYYY-MM-DD"));
                                                    } else {
                                                        handleSearchFiltersChange("dateRange", []);
                                                        handleSearchFiltersChange("datestart", null);
                                                        handleSearchFiltersChange("dateend", null);
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>

                            <div className="col-12">
                                <div className="col-md-12 d-flex justify-content-end">
                                    <button type="button" className="mr-1 me-2 btn"
                                            onClick={() => handleClearFilters()}>
                                        <i className="fa fa-eraser"></i> Limpar Filtros
                                    </button>


                                    <button type="button"
                                            className="mr-1 me-2 btn btn-success"
                                            onClick={() => fetchArrayCompany(1)}
                                            disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"
                                                  aria-hidden="true"></span>
                                                Buscando...
                                            </>
                                        ) : (
                                            <>
                                                <i className="fa fa-search me-1"></i> Buscar
                                            </>
                                        )}
                                    </button>


                                </div>
                            </div>

                        </div>


                        <div className="list-container mt-4">
                            {loading ? (
                                <Skeleton count={5}/>
                            ) : (
                                arrayCompany.length > 0 ? (
                                    arrayCompany.map((company) => (
                                        <Col lg={12} key={company.id}>
                                            <Card className="mb-1 p-2 shadow-sm card-hover">
                                                <CardBody
                                                    className="row card-body d-flex justify-content-between align-items-center p-2">

                                                    <div className="col-4 row d-flex align-items-center">
                                                        <div className="col-2 me-3">
                                                            <Avatar
                                                                src={company?.user_info?.profile_image || company.profile_image || process.env.REACT_APP_URL_STORAGE + "src/perfil_icone.png"}
                                                                alt={company?.user_info?.name || company?.name}
                                                                size={60}
                                                                className="me-2"
                                                            />
                                                        </div>
                                                        <div className="col-8 ms-2">
                                                            <h6 className="doc-name">{company?.user_info?.name || company?.name || "Usuário não identificado"}</h6>
                                                            <p className="text-muted mb-1">
                                                                <i className="fa fa-phone text-info me-2"></i>
                                                                Telefone: {
                                                                (company.user_info?.ddd && company.user_info?.phone)
                                                                    ? `(${company.user_info.ddd}) ${company.user_info.phone}`
                                                                    : (company.ddd && company.phone)
                                                                        ? `(${company.ddd}) ${company.phone}`
                                                                        : "Não informado"
                                                            }
                                                            </p>
                                                        </div>
                                                    </div>
                                                    <div className="col-5 col-sm-4 col-md-4">
                                                        <p className="mb-1">
                                                            <strong>Data
                                                                Cadastro:</strong> {moment(company.created_at).format('DD/MM/YYYY hh:mm')}
                                                        </p>
                                                        <p className="mb-1">
                                                            <strong>Última
                                                                Atualização:</strong> {moment(company.updated_at).format('DD/MM/YYYY hh:mm')}
                                                        </p>
                                                        <p className="mb-1">
                                                            <strong>Situação:</strong> &nbsp;&nbsp;
                                                            {company.situation === "pending" && (
                                                                <span className="text-warning">
                                                                                <i className="fa fa-times text-warning"></i> Pendente
                                                                            </span>
                                                            )}
                                                            {company.situation === "accepted" && (
                                                                <span className="text-success">
                                                                                <i className="fa fa-check text-success"></i> Aprovado
                                                                            </span>
                                                            )}
                                                            {company.situation === "refused" && (
                                                                <span className="text-danger">
                                                                                <i className="fa fa-close text-danger"></i> Rejeitado
                                                                            </span>
                                                            )}

                                                            {company.situation === "remake" && (
                                                                <span className="text-danger">
                                                                                <i className="fa fa-address-card text-danger"></i> Recusado Documentação
                                                                            </span>
                                                            )}
                                                        </p>
                                                    </div>
                                                    <div className="col-3 ms-2">
                                                        <p className="text-muted mb-1">
                                                            <i className="fa fa-check-circle text-success me-2"></i>
                                                            Plantões Totais: {company?.duty_info?.duties_completed || 0}
                                                        </p>
                                                        <p className="text-muted mb-1">
                                                            <i className="fa fa-share-square text-warning me-2"></i>
                                                            Plantões Transferidos: {company?.duty_info?.duties_transferred || 0}
                                                        </p>
                                                    </div>

                                                    <div className="col-1 d-flex flex-column align-items-stretch">
                                                        <div className="position-relative mb-1">
                                                            <button type="button"
                                                                    className="btn btn-outline-info w-100 py-1 px-2 btn-sm"
                                                                    onClick={() => handleModalComments(company)}
                                                            >
                                                                <i className="fa fa-comment me-1"></i> Avaliar
                                                            </button>
                                                            {company?.history?.length > 0 && (
                                                                <span
                                                                    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
                                                                    style={{fontSize: '0.65rem'}}
                                                                    title="Tentativas de credenciamento"
                                                                >
                                                                    {company.history.length}
                                                                  </span>
                                                            )}
                                                        </div>

                                                        {/* Botão Rejeitar */}
                                                        {(company.situation === "pending" || company.situation === "remake") && (
                                                            <button type="button"
                                                                    className="btn btn-outline-danger w-100 mb-1 py-1 px-2 btn-sm"
                                                                    onClick={() => handleReject(company)}
                                                            >
                                                                <i className="fa fa-times me-1"></i> Rejeitar
                                                            </button>
                                                        )}

                                                        {/* Botão Aprovar */}
                                                        {(["pending", "refused", "remake"].includes(company.situation)) && (
                                                            <button type="button"
                                                                    className="btn btn-outline-primary w-100 py-1 px-2 btn-sm"
                                                                    onClick={() => handleApprove(company)}
                                                            >
                                                                <i className="fa fa-check me-1"></i> Aprovar
                                                            </button>
                                                        )}
                                                    </div>


                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    <div className="card duty-card shadow-sm mb-3">
                                        <div className="card-body">
                                            <div className="alert alert-primary" role="alert">Nenhuma
                                                solicitação
                                                encontrada.
                                            </div>
                                        </div>
                                    </div>
                                )
                            )}

                            <CustomPagination
                                className="mt-4"
                                pagination={pagination}
                                onChange={handlePageChange}
                            />
                        </div>

                        <AccreditationCommentsModal
                            show={showCommentsModal}
                            onHide={closeCommentsModal}
                            user={selectedUser}
                        />


                    </Row>
                </Container>
            </div>
        </React.Fragment>
);
};

export default ManagersAvaliableUserPage;
